module.exports = __webpack_public_path__ + "static/reversal_icon-129bf1f17412d9508b5640fcfa1e86e4.svg";